import ListPageView from "../../components/ListPageView"

export default function EmployerContactLog() {
  const ID_TEMPLATE = "activity_employer_contact"
  const ID_BLOCKS = ["activity__employer_contact_log", "activity"]

  const listViewCols = [
    {
      header: "Date",
      field: "activity_date",
      block: "activity",
      type: "date",
    },
    {
      header: "Contact Organization",
      field: "employer_contact_organization",
      block: "activity__employer_contact_log",
      type: "string",
    },
    {
      header: "Follow Up",
      field: "employer_contact_followup_date",
      block: "activity__employer_contact_log",
      type: "date",
    },
    {
      header: "Submitted By",
      field: "staff_full_name",
      block: "activity",
      type: "staff",
    },
    {
      header: "Location",
      field: "activity__location_ids",
      block: "activity",
      type: "location",
    },
    {
      header: "Program ID",
      field: "activity__program_identity_ids",
      block: "activity",
      type: "program",
    },
  ]

  return (
    <div className="main-content">
      <ListPageView
        idTemplate={ID_TEMPLATE}
        idBlocks={ID_BLOCKS}
        columns={listViewCols}
      />
    </div>
  )
}
